import React, { useCallback, useRef } from 'react';
import { Container } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { ContainerButton, Input, TextTitle, Title } from '../../../../../styles/global';
import Panel from '../../../../../components/Panel';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faX } from '@fortawesome/free-solid-svg-icons';
import useSolicitanteExterno from '../../../../../actions/cruds/Protocolo/useSolicitanteExterno';

const SolicitanteExternoCreate: React.FC = () => {

    const { createSolicitanteExterno } = useSolicitanteExterno();

    const formRef = useRef<FormHandles>(null);

    const handleSubmit = useCallback(
        async (data: object) => {
            try {
                console.log("data", data);
                createSolicitanteExterno(data);
            } catch (err) {
                console.log(err)
            }
        }, [],
    );

    return (
        <Container>
            <Title>
                <span>Cadastrar Solicitante Externo</span>
            </Title>

            <Form id="form1" ref={formRef} onSubmit={handleSubmit} >
                <Panel titulo='Solicitante Externo'>
                    <Grid container spacing={6}>
                        <Grid xs={12}>
                            <TextTitle>Nome:</TextTitle>
                            <Input type="text" name='nome' required/>
                        </Grid>
                        <Grid xs={6}>
                            <TextTitle>Telefone:</TextTitle>
                            <Input type="text" name='telefone' mask='phone' />
                        </Grid>
                        <Grid xs={6}>
                            <TextTitle>Email:</TextTitle>
                            <Input type="email" name='email' />
                        </Grid>
                        <Grid xs={12}>
                            <TextTitle>Local de referência:</TextTitle>
                            <Input type="text" name='local' required/>
                        </Grid>
                    </Grid>
                </Panel>
                <ContainerButton>
                    <Link to="/protocolo/cadastros/solicitante_externo">
                        <button><FontAwesomeIcon icon={faX} size="1x" /> Cancelar</button>
                    </Link>
                    <button type="submit" form="form1"><FontAwesomeIcon icon={faSave} /> Salvar</button>
                </ContainerButton>
            </Form>
        </Container>
    );
};

export default SolicitanteExternoCreate;